import { apiClient } from './api';

export interface CuisineFilterItem {
  id: string;
  name: string;
  image: string;
  keywords: string[];
}

const DEFAULT_CUISINE_IMAGE =
  'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=500&auto=format&fit=crop';

let cuisineFilterCache: CuisineFilterItem[] | null = null;

export async function getCuisineFilterItems(): Promise<CuisineFilterItem[]> {
  if (cuisineFilterCache) {
    return cuisineFilterCache;
  }

  const allCuisine: CuisineFilterItem = {
    id: 'all',
    name: 'Tümü',
    image: DEFAULT_CUISINE_IMAGE,
    keywords: [],
  };

  try {
    const response = await apiClient.get<{
      data: Array<{
        id: string;
        name: string;
        imageUrl: string | null;
        keywords: string[] | null;
        isActive?: boolean;
      }>;
    }>('/cuisine-categories');

    const cuisines = (response.data.data ?? [])
      .filter((cuisine) => cuisine.isActive !== false)
      .map((cuisine) => ({
        id: cuisine.id,
        name: cuisine.name,
        image: cuisine.imageUrl ?? DEFAULT_CUISINE_IMAGE,
        keywords: cuisine.keywords ?? [],
      }));

    cuisineFilterCache = [allCuisine, ...cuisines];
    return cuisineFilterCache;
  } catch {
    cuisineFilterCache = [allCuisine];
    return cuisineFilterCache;
  }
}
